import { environment as baseEnv } from './environment.base';
export const environment = {
  ...baseEnv,
  production: false,
  app_version: 'dev-1757319793',
  env: 'dev',
  google_api_key: 'AIzaSyCPOyxpzmCODTmYlcVskt7x7ibwrUHBpzg',
  api_url: 'https://services.dev.epione.net/patient-onboard',
};
